import React from 'react';
import {Modal, Spinner, Button} from 'react-bootstrap';
import {PDFDownloadLink} from '@react-pdf/renderer';
import {BingoCard, BingoTheme} from '../types';
import BingoPDF from './BingoPDF';
import AdArea from './AdArea';

interface BingoModalProps {
    show: boolean;
    onHide: () => void;
    isLoading: boolean;
    generatedCards: BingoCard[] | null;
    imagesMap: Record<string, string>;
    logoDataMap: Record<string, string>;
    type: string;
    names: string[];
    theme: BingoTheme;
}

const BingoModal: React.FC<BingoModalProps> = ({
    show,
    onHide,
    isLoading,
    generatedCards,
    imagesMap,
    logoDataMap,
    type,
    names,
    theme
}) => {
    console.log(
        "[DEBUG_LOG] BingoModal - Rendering modal. show:",
        show,
        "isLoading:",
        isLoading,
        "cards:",
        generatedCards?.length
    );

    const handleClose = () => {
        console.log("[DEBUG_LOG] BingoModal.handleClose - Closing modal");
        onHide();
    };

    return (
        <Modal show={show} centered backdrop="static" keyboard={false} style={{ color: 'var(--bingo-text)' }}>
            <Modal.Header closeButton onHide={handleClose} style={{ backgroundColor: 'var(--bingo-card-bg)', borderBottomColor: 'var(--bingo-border)' }}>
                <Modal.Title style={{ color: 'var(--bingo-text)' }}>Gerando Cartelas de Bingo</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center" style={{ backgroundColor: 'var(--bingo-card-bg)' }}>
                {isLoading ? (
                    <div className="py-5">
                        <Spinner animation="grow" variant="danger" className="mb-3"/>
                        <p className="lead font-weight-bold">Sorteando os números...</p>
                        <p className="small" style={{ color: 'var(--bingo-text-muted)' }}>Suas cartelas personalizadas estarão prontas em instantes.</p>
                    </div>
                ) : (
                    <div className="py-5">

                    </div>
                )}
            </Modal.Body>
            <AdArea />
            <Modal.Footer className="justify-content-center border-top-0 pt-0 pb-4" style={{ backgroundColor: 'var(--bingo-card-bg)', borderTopColor: 'var(--bingo-border)' }}>
                {!isLoading && (
                    <div className="d-flex gap-2 w-100 px-3">
                        {generatedCards ? (
                            <>
                                <Button variant="secondary" onClick={handleClose}
                                        className="flex-fill rounded-pill py-2">
                                    CANCELAR
                                </Button>
                                <PDFDownloadLink
                                    onClick={() => {
                                        console.log("[DEBUG_LOG] BingoModal.PDFDownloadLink - Download clicked, closing modal");
                                        setTimeout(
                                            handleClose,
                                            1000
                                        );
                                    }}
                                    document={
                                        <BingoPDF
                                            cards={generatedCards}
                                            imagesMap={imagesMap}
                                            logoDataMap={logoDataMap}
                                            type={type}
                                            names={names}
                                            theme={theme}/>
                                    }
                                    fileName="cartelas_bingo.pdf"
                                    className="btn btn-success flex-fill rounded-pill py-2 font-weight-bold"
                                    style={{backgroundColor: 'var(--bingo-green)', border: 'none'}}
                                >
                                    {({loading}) => {
                                        console.log(
                                            "[DEBUG_LOG] BingoModal.PDFDownloadLink - Loading:",
                                            loading
                                        );
                                        return <span>{loading ? 'PROCESSANDO...' : 'BAIXAR CARTELAS (PDF)'}</span>;
                                    }}
                                </PDFDownloadLink>
                            </>
                        ) : (
                            <Button variant="danger" onClick={handleClose} className="w-100 rounded-pill py-2">
                                TENTAR NOVAMENTE
                            </Button>
                        )}
                    </div>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default BingoModal;
